export default "__VITE_ASSET__wdLrJXVd__"